<template>
  <div style="max-height: 300px" class="table-responsive">
    <table>
      <thead>
        <tr>
          <th width="25%">Código de barra</th>
          <th width="50%">Ítem</th>
          <th width="15%">Cantidad</th>
          <th>
            <div>
              <!-- <button
                v-show="editable"
                type="button"
                @click="agregar"
                class="btn-success"
              >
                <i class="fa fa-plus"></i>
              </button> -->
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          :index="index"
          :editable="editable"
          v-for="(item, index) in items"
          :key="index"
          is="tr-item-visita"
          v-model="items[index]"
          @eliminar="eliminar"
        ></tr>
        <tr v-show="items.length === 0">
          <td colspan="4">
            <strong>No se ha agregado ítems.</strong>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import TrItemVisita from "./TrItemVisita.vue";
export default {
  components: {
    TrItemVisita,
  },
  props: {
    editable: {
      type: Boolean,
      required: false,
      default: true,
    },
    value: {
      type: Array,
      required: false,
      default: function () {
        return [];
      },
    },
  },
  methods: {
    agregar: function () {
      this.items.push({
        item_id: "",
        codigo_barra: "",
        cantidad: 1,
      });
    },
    eliminar: function (index) {
      this.items.splice(index, 1);
    },
    importar: function () {},
  },
  data: function () {
    return {
      items: this.value,
    };
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/logistica/visitas/ItemsVisitas.vue